import {performHttpRequest} from "@/http/http";

export async function getFilters() {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/filters',
        'GET',
    )
}

export async function getFilterDomainList(url, data) {
    return performHttpRequest(
        url,
        'POST',
        data
    )
}

export async function filterDownload(url, data) {
    return performHttpRequest(
        url,
        'POST',
        data
    )
}
